/// Public inbox for player support. Inbox lives on dinodash.xyz mail.
export const supportEmail = 'support@dinodash.xyz';
